module.exports = __webpack_public_path__ + "img/logo.854f5155.png";